import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: center;
  flex: 1;

  &:not(.transparent) {
    box-shadow: 0 2px 4px 2px rgba(182, 187, 200, 0.15);
    border-radius: 8px;
    background: #fff;
    //margin: 0 0 25px;
  }

  svg {
    animation: lds-rolling 1.5s linear infinite;
    overflow: hidden;
    transform-origin: 50%;
  }

  @keyframes lds-rolling {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loader = (props) => {
  const { background, className } = props;

  return (
    <Wrap
      className={`flex api-loader${className ? ` ${className}` : ""}${
        background ? "" : " transparent"
      }`}
    >
      <svg width="50px" height="50px">
        <use xlinkHref="#loader" />
      </svg>
    </Wrap>
  );
};

export default Loader;
